export default __webpack_public_path__ + "static/media/querelle_detail6.d6431c98.jpg";